<div class="modal-header">
  <h5 class="modal-title">Editar projeto</h5>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="dismiss()"
  ></button>
</div>

<div class="modal-body" [formGroup]="projectForm">
  <div class="mb-3">
    <div class="row align-items-end g-2">
      <div class="col-md-8">
        <label class="form-label">ID da Conta</label>
        <input
          type="text"
          class="form-control"
          [value]="accountGuid || '-'"
          readonly
        />
      </div>

      <div class="col-md-4">
        <button
          type="button"
          class="btn btn-pill btn-primary w-100"
          (click)="copyGuid()"
          [disabled]="!accountGuid"
        >
          <i class="fe fe-copy me-2"></i>Copiar ID
        </button>
      </div>
    </div>
  </div>

  <div class="modal-body" [formGroup]="projectForm">
    <mat-accordion [multi]="false">
      <mat-expansion-panel
        [expanded]="isProjectExpanded"
        (expandedChange)="isProjectExpanded = $event"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>Dados do Projeto</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row g-3" formGroupName="operatorRegistration">
          <div class="col-md-6">
            <label class="form-label">Nome do Projeto</label>
            <input
              type="text"
              class="form-control"
              formControlName="nameProject"
            />
          </div>

          <div class="col-md-6">
            <label class="form-label">Site</label>
            <input type="text" class="form-control" formControlName="site" />
          </div>

          <div class="col-md-6">
            <label class="form-label">Licenciamento</label>
            <input
              type="text"
              class="form-control"
              [value]="licensingLabel(licensingId)"
              readonly
            />
          </div>

          <div class="col-md-6">
            <label class="form-label">Banco</label>
            <input
              type="text"
              class="form-control"
              formControlName="bankProvider"
              readonly
            />
          </div>

          <div class="col-md-6">
            <label class="form-label">Plataforma</label>
            <ng-select
              appendTo="body"
              [items]="platformOptions"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              [searchable]="false"
              [loading]="platformsLoading"
              formControlName="currentPlatform"
            ></ng-select>
          </div>

          <div class="col-md-6">
            <label class="form-label">Percentual GGR</label>
            <input
              type="number"
              class="form-control"
              formControlName="percentGGR"
            />
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        [expanded]="isCompanyExpanded"
        (expandedChange)="isCompanyExpanded = $event"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>Empresa</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row g-3" formGroupName="company">
          <div class="col-md-4">
            <label class="form-label">CNPJ</label>
            <input
              type="text"
              class="form-control"
              formControlName="cnpj"
              mask="CPF_CNPJ"
              readonly
            />
          </div>

          <div class="col-md-8">
            <label class="form-label">Razão Social</label>
            <input
              type="text"
              class="form-control"
              formControlName="razaoSocial"
            />
          </div>

          <div class="col-md-6">
            <label class="form-label">Email</label>
            <input type="text" class="form-control" formControlName="email" />
          </div>

          <div class="col-md-6">
            <label class="form-label">Telefone</label>
            <input type="text" class="form-control" formControlName="phone" />
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        [expanded]="isAddressExpanded"
        (expandedChange)="isAddressExpanded = $event"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>Endereço</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row g-3" formGroupName="adress">
          <div class="col-md-6">
            <label class="form-label">Logradouro</label>
            <input
              type="text"
              class="form-control"
              formControlName="logradouro"
            />
          </div>

          <div class="col-md-2">
            <label class="form-label">Número</label>
            <input type="text" class="form-control" formControlName="numero" />
          </div>

          <div class="col-md-4">
            <label class="form-label">Complemento</label>
            <input
              type="text"
              class="form-control"
              formControlName="complemento"
            />
          </div>

          <div class="col-md-3">
            <label class="form-label">CEP</label>
            <input type="text" class="form-control" formControlName="cep" />
          </div>

          <div class="col-md-3">
            <label class="form-label">Bairro</label>
            <input type="text" class="form-control" formControlName="bairro" />
          </div>

          <div class="col-md-4">
            <label class="form-label">Cidade</label>
            <input type="text" class="form-control" formControlName="cidade" />
          </div>

          <div class="col-md-2">
            <label class="form-label">Estado</label>
            <input type="text" class="form-control" formControlName="estado" />
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        [expanded]="isSponsorExpanded"
        (expandedChange)="isSponsorExpanded = $event"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>Responsável</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row g-3" formGroupName="sponsor">
          <div class="col-md-4">
            <label class="form-label">CPF</label>
            <input
              type="text"
              class="form-control"
              formControlName="cpf"
              mask="CPF_CNPJ"
            />
          </div>

          <div class="col-md-8">
            <label class="form-label">Nome</label>
            <input type="text" class="form-control" formControlName="name" />
          </div>

          <div class="col-md-6">
            <label class="form-label">Email</label>
            <input type="text" class="form-control" formControlName="email" />
          </div>

          <div class="col-md-6">
            <label class="form-label">Telefone</label>
            <input type="text" class="form-control" formControlName="phone" />
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        [expanded]="isFinancialExpanded"
        (expandedChange)="isFinancialExpanded = $event"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>Limites Financeiros</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label">Depósito (Por transação) - Mínimo</label>
            <input
              type="text"
              class="form-control"
              formControlName="depositValueMinRequest"
              currencyMask
              [options]="{ prefix: 'R$ ', allowNegative: false }"
              [class.is-invalid]="hasRangeError('deposit')"
            />
          </div>

          <div class="col-md-6">
            <label class="form-label">Depósito (Por transação) - Máximo</label>
            <input
              type="text"
              class="form-control"
              formControlName="depositValueMaxRequest"
              currencyMask
              [options]="{ prefix: 'R$ ', allowNegative: false }"
              [class.is-invalid]="hasRangeError('deposit')"
            />
            <div *ngIf="hasRangeError('deposit')" class="mt-1">
              <small class="text-danger"
                >O valor máximo de depósito não pode ser menor que o
                mínimo.</small
              >
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label"
              >Limite de Saque Automático (Por transação)</label
            >
            <input
              type="text"
              class="form-control"
              formControlName="valorMinimoSaqueAutomatico"
              currencyMask
              [options]="{ prefix: 'R$ ', allowNegative: false }"
            />
          </div>

          <div class="col-md-6">
            <label class="form-label"
              >Quantidade de Saque em 24h (Por recebedor)</label
            >
            <input
              type="number"
              class="form-control"
              formControlName="amountExpired"
            />
          </div>

          <div class="col-md-6">
            <label class="form-label"
              >Limite de Saque em 24h (Por recebedor)</label
            >
            <input
              type="text"
              class="form-control"
              formControlName="valueExpired"
              currencyMask
              [options]="{ prefix: 'R$ ', allowNegative: false }"
            />
          </div>

          <div class="col-md-6">
            <label class="form-label d-block"
              >Cancelamento Automático de Saque</label
            >
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="analyzeWithdrawal"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-md-6">
            <label class="form-label">Saque (Por transação) - Mínimo</label>
            <input
              type="text"
              class="form-control"
              formControlName="valueMinRequest"
              currencyMask
              [options]="{ prefix: 'R$ ', allowNegative: false }"
              [class.is-invalid]="hasRangeError('withdraw')"
            />
          </div>

          <div class="col-md-6">
            <label class="form-label">Saque (Por transação) - Máximo</label>
            <input
              type="text"
              class="form-control"
              formControlName="valueMaxRequest"
              currencyMask
              [options]="{ prefix: 'R$ ', allowNegative: false }"
              [class.is-invalid]="hasRangeError('withdraw')"
            />
            <div *ngIf="hasRangeError('withdraw')" class="mt-1">
              <small class="text-danger"
                >O valor máximo de saque não pode ser menor que o mínimo.</small
              >
            </div>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        [expanded]="isPermissionsExpanded"
        (expandedChange)="isPermissionsExpanded = $event"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>Permissões</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row g-3">
          <div class="col-md-4">
            <label class="form-label d-block">Permissão Saque</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="permissonWithdraw"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-md-4">
            <label class="form-label d-block">Permissão Depósito</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="permissonDeposit"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-md-4">
            <label class="form-label d-block">Permissão TEF</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="permissonTef"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-md-4">
            <label class="form-label d-block">Permissão Crypto</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="permissonCrypto"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-md-4">
            <label class="form-label d-block">Permission Game API</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="permissionGameApi"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-md-4">
            <label class="form-label d-block">Bloqueio de Jogadores</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="userBlackList"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-md-4">
            <label class="form-label d-block"
              >Bloquear Depósito de Terceiro</label
            >
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="featureFlagRefundPix"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-md-4">
            <label class="form-label d-block"
              >Bloquear Saque para Terceiro</label
            >
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="featureFlagCpfWithdraw"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-md-4">
            <label class="form-label d-block">Alta Performace de Saldo</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="featureFlagCustomerBalance"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-md-4">
            <label class="form-label d-block">Exibir Três Decimais</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="featureFlagNewParam"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        [expanded]="isListCnpjExpanded"
        (expandedChange)="isListCnpjExpanded = $event"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>Lista CNPJ</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row g-3" formGroupName="listCnpj">
          <div class="col-md-6">
            <label class="form-label d-block">Bloquear Depósito via CNPJ</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="flagCnpjCashIn"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-md-6">
            <label class="form-label d-block">Bloquear Saque via CNPJ</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="flagCnpjCashOut"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Lista de Cnpj Autorizados - Depósito</mat-label>

              <mat-chip-grid
                #chipGridIn
                aria-label="Lista de Cnpj Autorizados - Depósito"
              >
                <mat-chip-row
                  *ngFor="
                    let c of projectForm.controls.listCnpj.controls.cnpjCashIn
                      .value ?? []
                  "
                  (removed)="removeCnpj(c, 'in')"
                >
                  {{ c }}
                  <button matChipRemove type="button" aria-label="Remover CNPJ">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>

                <input
                  matInput
                  placeholder="Lista de Cnpj Autorizados - Depósito"
                  [matChipInputFor]="chipGridIn"
                  [matChipInputSeparatorKeyCodes]="separatorKeys"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addCnpj($event, 'in')"
                />
              </mat-chip-grid>
            </mat-form-field>
          </div>

          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Lista de Cnpj Autorizados - Saque</mat-label>

              <mat-chip-grid
                #chipGridOut
                aria-label="Lista de Cnpj Autorizados - Saque"
              >
                <mat-chip-row
                  *ngFor="
                    let c of projectForm.controls.listCnpj.controls.cnpjCashOut
                      .value ?? []
                  "
                  (removed)="removeCnpj(c, 'out')"
                >
                  {{ c }}
                  <button matChipRemove type="button" aria-label="Remover CNPJ">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>

                <input
                  matInput
                  placeholder="Lista de Cnpj Autorizados - Saque"
                  [matChipInputFor]="chipGridOut"
                  [matChipInputSeparatorKeyCodes]="separatorKeys"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addCnpj($event, 'out')"
                />
              </mat-chip-grid>
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        [expanded]="isIpExpanded"
        (expandedChange)="isIpExpanded = $event"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>Liberação de IP</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row g-3">
          <div class="col-md-6">
            <label class="form-label d-block">Validar IP</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="validateIp"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Lista de IPs Autorizados</mat-label>

              <mat-chip-grid #chipGridIp aria-label="Lista de IPs Autorizados">
                <mat-chip-row
                  *ngFor="let ip of projectForm.controls.listsIp.value ?? []"
                  (removed)="removeIp(ip)"
                >
                  {{ ip }}
                  <button matChipRemove type="button" aria-label="Remover IP">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>

                <input
                  matInput
                  placeholder="Digite o IP"
                  [matChipInputFor]="chipGridIp"
                  [matChipInputSeparatorKeyCodes]="separatorKeys"
                  [matChipInputAddOnBlur]="true"
                  (matChipInputTokenEnd)="addIp($event)"
                />
              </mat-chip-grid>
            </mat-form-field>
          </div>
        </div>
      </mat-expansion-panel>

      <mat-expansion-panel
        [expanded]="isCertificateExpanded"
        (expandedChange)="isCertificateExpanded = $event"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>Certificado mTLS</mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row g-3" formGroupName="mtls">
          <div class="col-md-4">
            <label class="form-label d-block">Depósito</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="deposit"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-md-4">
            <label class="form-label d-block">Saque</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="withdraw"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>

          <div class="col-md-4">
            <label class="form-label d-block">TEF</label>
            <label class="custom-switch mt-2">
              <input
                type="checkbox"
                class="custom-switch-input"
                formControlName="tef"
              />
              <span class="custom-switch-indicator"></span>
            </label>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary btn-pill"
      (click)="save()"
      [disabled]="isSaving || validatingPassword || projectForm.invalid"
    >
      Salvar
    </button>
  </div>

  <ng-template #requestPasswordInsert let-modal>
    <div class="modal-header">
      <h5 class="modal-title">Informe a senha</h5>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss()"
      ></button>
    </div>

    <div class="modal-body">
      <div class="form-group mt-2">
        <p *ngIf="errorMessage && errorMessage.length > 0" class="text-danger">
          {{ errorMessage }}
        </p>
      </div>

      <div class="form-group mb-3">
        <input
          type="password"
          class="form-control"
          placeholder="Senha"
          [(ngModel)]="passwordInsert"
          [ngModelOptions]="{ standalone: true }"
          (keyup.enter)="confirmPasswordInsert()"
        />
      </div>
    </div>

    <div class="modal-footer text-center">
      <button
        type="button"
        class="btn btn-lg btn-primary btn-pill mx-auto d-block"
        (click)="confirmPasswordInsert()"
        [disabled]="validatingPassword || isSaving"
      >
        VALIDAR
      </button>
    </div>
  </ng-template>
</div>
